const translations = {
  "en": {
    "Portfolio Health Check": "Portfolio Health Check",
    "What happened today?": "What happened today?"
  },
  "zh-tw": {
    "Portfolio Health Check": "投資組合健康檢查",
    "What happened today?": "今天發生什麼事了？"
  }
};

export default translations;
